"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var format_price_1 = __importDefault(require("../../../utils/format-price"));
var app_1 = require("../app");
var Cookies = __importStar(require("js-cookie"));
var loading_modal_1 = __importDefault(require("../../account-v3/components/loading_modal"));
var useContext = react_1.default.useContext, useMemo = react_1.default.useMemo;
var Nav = function (_a) {
    var afterNext = _a.afterNext, canGoNext = _a.canGoNext, centerContent = _a.centerContent, history = _a.history;
    var context = useContext(app_1.AppContext);
    if (!context)
        return null;
    var bundlerSteps = context.bundlerSteps, bundlerSubSteps = context.bundlerSubSteps, currentStepIdx = context.currentStepIdx, currentSubStepIdx = context.currentSubStepIdx, handleFinalSubmitClick = context.handleFinalSubmitClick, isHandlingFinalSubmitClick = context.isHandlingFinalSubmitClick, isEditingExistingBundle = context.isEditingExistingBundle, isTestingExpandedMobileLayout = context.isTestingExpandedMobileLayout, price = context.price, priceWithPromotionalProducts = context.priceWithPromotionalProducts, existingCustomerNewBundleParams = context.existingCustomerNewBundleParams;
    // steps that allow user to save if editing bundle instead of going through the rest of the bundler steps
    var saveBundleSteps = ['select-prints', 'select-discount-add-ons'];
    var disallowBackButtonSteps = ['select-discount-add-ons'];
    var findPath = function (idx) {
        var subStep = bundlerSubSteps[currentStepIdx][currentSubStepIdx + idx];
        if (subStep) {
            return "/".concat(bundlerSteps[currentStepIdx], "/").concat(subStep);
        }
        var step = bundlerSteps[currentStepIdx + idx];
        if (step) {
            var substeps = bundlerSubSteps[currentStepIdx + idx];
            var stepSubstep = substeps.length > 1 && substeps[idx < 0 ? substeps.length - 1 : 0];
            if (stepSubstep) {
                return "/".concat(step, "/").concat(stepSubstep);
            }
            return "/".concat(step);
        }
    };
    var hasSubStep = useMemo(function () { return !!bundlerSubSteps[currentStepIdx][currentSubStepIdx + 1]; }, [currentStepIdx, currentSubStepIdx, bundlerSubSteps]);
    var nextPath = useMemo(function () { return findPath(1); }, [currentStepIdx, currentSubStepIdx, bundlerSubSteps]);
    var prevPath = useMemo(function () { return findPath(-1); }, [currentStepIdx, currentSubStepIdx, bundlerSubSteps]);
    var currentStep = bundlerSteps[currentStepIdx];
    var handleNextStepClick = function () { return function () {
        if (nextPath && canGoNext) {
            history.push(nextPath);
            if (afterNext) {
                afterNext();
            }
        }
    }; };
    var defaultCenterContent = function () {
        if (!Cookies.get('abPreviousBundlePricing'))
            return null;
        var formattedPrice = currentStep === 'confirm' ? (0, format_price_1.default)(priceWithPromotionalProducts) : (0, format_price_1.default)(price);
        var formattedPriceMatch = formattedPrice.match(/(^.+)?\.(.+)/);
        var dollars = formattedPriceMatch ? formattedPriceMatch[1] : null;
        var cents = formattedPriceMatch ? formattedPriceMatch[2] : null;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'large-price lh1 font-bold' },
                dollars,
                react_1.default.createElement("span", { className: 'cents' }, cents)),
            react_1.default.createElement("div", { className: 'text-nobel margin-top-1' },
                react_1.default.createElement("small", null, "Per Shipment"))));
    };
    var getFinalButtonText = (0, react_1.useCallback)(function () {
        if (isHandlingFinalSubmitClick) {
            return 'Wait...';
        }
        if (existingCustomerNewBundleParams) {
            return 'Place Order';
        }
        if (window.OPTIMIZE_REDIRECT_BUNDLER_TO_CHECKOUT) {
            return 'Checkout';
        }
        return 'Add to Cart';
    }, [isHandlingFinalSubmitClick]);
    return (react_1.default.createElement("div", { className: "bundler-app-nav grid-x align-justify align-middle border-seashell bordered ".concat(isTestingExpandedMobileLayout ? 'responsive-bar' : 'padding-4', " "), style: { borderWidth: '1px 0 0' } },
        react_1.default.createElement(loading_modal_1.default, { isLoading: isHandlingFinalSubmitClick && !!existingCustomerNewBundleParams, error: false }),
        (function () {
            var shouldHideBackButton = isEditingExistingBundle && disallowBackButtonSteps.includes(currentStep);
            var isBackButtonVisible = shouldHideBackButton ? false : !!prevPath;
            return (react_1.default.createElement("div", { className: 'cell shrink', style: { maxWidth: '148px' } },
                react_1.default.createElement(react_router_dom_1.Link, { className: "nav-button back width-100 ".concat(isTestingExpandedMobileLayout ? 'responsive-button' : ''), to: prevPath || '', style: { visibility: isBackButtonVisible ? 'visible' : 'hidden' } }, "\u2190 Back")));
        })(),
        react_1.default.createElement("div", { className: 'cell auto text-center' },
            react_1.default.createElement("div", { id: "center-content-".concat(currentStepIdx) }, centerContent || defaultCenterContent())),
        react_1.default.createElement("div", { className: 'cell shrink', style: { maxWidth: '148px' } }, (function () {
            // no need to go through the rest of the steps when editing bundle
            // 'next' button should be replaced with 'save' if it user is editing just that one step and it has no substeps
            var isSaveStep = isEditingExistingBundle && saveBundleSteps.includes(currentStep) && !hasSubStep;
            if (isSaveStep) {
                return (react_1.default.createElement("button", { className: (0, classnames_1.default)('nav-button', canGoNext && 'active', isTestingExpandedMobileLayout && 'responsive-button'), onClick: handleFinalSubmitClick, dangerouslySetInnerHTML: { __html: 'Save' } }));
            }
            else if (nextPath) {
                return (react_1.default.createElement("button", { onClick: handleNextStepClick(), className: (0, classnames_1.default)('nav-button width-100', canGoNext && 'active', isTestingExpandedMobileLayout && 'responsive-button') }, "Next \u2192"));
            }
            else {
                return (react_1.default.createElement("button", { className: "nav-button active ".concat(isTestingExpandedMobileLayout ? 'responsive-button' : ''), onClick: handleFinalSubmitClick, dangerouslySetInnerHTML: { __html: getFinalButtonText() } }));
            }
        })())));
};
exports.default = (0, react_router_dom_1.withRouter)(Nav);
